'use strict';

import React, { PropTypes } from 'react';

const RepublicanColor = '#a90213';
const DemocraticColor = '#0064a5';

const ProportionBar = React.createClass({
  displayName: "ProportionBar",
  propTypes: {
    total: PropTypes.number,
    part: PropTypes.number,
    party: PropTypes.string,
    showingPercentage: PropTypes.bool,
    delegates: PropTypes.number
  },
  render() {
    const {total, part, party, showingPercentage, delegates} = this.props;
    const percent = (Math.round(part / total * 100)) + '%';
    const color = party === 'r' ? RepublicanColor : DemocraticColor;
    const num = showingPercentage ? `${Math.round(part)}%` : `${delegates} st`;
    const css = require('./ProportionBar.scss');

    return (
      <div className={css.outerBar}>
        <p className={css.percentage}>{num}</p>
        <div className={css.innerBar} style={{width: percent, backgroundColor: color}}></div>
      </div>
    );
  }
});

export default ProportionBar;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/ProportionBar.js
 **/